<template>
  <LoadingDiv v-if="!isReady" />

  <template v-else>
    <!-- <div class="row">
      <div class="col s12"> -->
        <form @submit.prevent="handleNext">
          <div class="section">
            <div class="card z-depth-0 grey lighten-4">
              <div class="card-content">
                <span class="card-title teal-text"
                  ><span class="chip">5/6</span> Settings<i
                    class="material-icons right"
                    >check_circle</i
                  ></span
                >
              </div>

              <div class="card-panel">
                <div class="input-field">
                  <input
                    id="familySize"
                    type="number"
                    v-model="familySize"
                    class="validate"
                    required
                  />
                  <label class="active" for="familySize"
                    >Family Size (total)</label
                  >
                </div>
                <span class="chip"
                  >Default: Principal, Spouse and 4 Dependants: Total (6)
                  members</span
                >
              </div>

              <div class="card-panel">
                <div class="input-field">
                  <input
                    id="prinipalAge"
                    type="number"
                    v-model="principalAge"
                    class="validate"
                    required
                  />
                  <label class="active" for="prinipalAge"
                    >Principal Age (Max)</label
                  >
                </div>
                <span class="chip"
                  >Default: Principal and Spouse: Maximum (60) years</span
                >
              </div>

              <div class="card-panel">
                <div class="input-field">
                  <input
                    id="dependantAge"
                    type="number"
                    v-model="dependantAge"
                    class="validate"
                    required
                  />
                  <label class="active" for="dependantAge"
                    >Dependant Age (Max)</label
                  >
                </div>
                <span class="chip">Default: Dependant: Maximum (18) years</span>
              </div>

              <div class="onboard-action-row">
                <a
                  href="#"
                  class="waves-effect waves-light btn-large black"
                  @click.prevent="handleBack()"
                >
                  <i class="material-icons left">chevron_left</i
                  > Back
                </a>

                <button
                  class="waves-effect waves-light btn-large blue"
                  :class="{
                    disabled: isSubmitting,
                  }"
                >
                <i class="material-icons left">chevron_right</i> {{ isSubmitting ? "Loading..." : "Next" }}
                </button>
              </div>
            </div>
          </div>
        </form>
      <!-- </div>
    </div> -->
  </template>
</template>
  
<script>
import { onMounted, ref } from "vue";
import getItems from "@/composables/getItems";
// import postItem from "@/composables/postItem";
import LoadingDiv from "@/components/LoadingDiv.vue";

export default {
  name: "HmoComponent",
  components: { LoadingDiv },
  emits: ["back", "next"],
  props: ["cat", "newClient"],
  setup(props, context) {
    const response = ref([]);
    const error = ref(null);
    const isSubmitting = ref(false);
    const isReady = ref(false);

    // Rules table
    const familySize = ref(null);
    const principalAge = ref(null);
    const dependantAge = ref(null);

    // check for back
    onMounted(() => {
      if (props?.newClient?.settings) {
      // reload
      familySize.value = props?.newClient?.settings?.[0].value;
      principalAge.value = props?.newClient?.settings?.[1].value;
      dependantAge.value = props?.newClient?.settings?.[2].value;
      isReady.value = true;
     }
    });

    // start here
    onMounted(() => {

      // get default items
      (async () => {
        const { res, err } = await getItems("rules?q=0"); // default settings

        if (res.value) {
          // get
          response.value = res.value.data;

          // set
          response.value.forEach((x) => {
            if (x.setting == "familySize" && familySize.value == null) {
              // set
              familySize.value = x.value;
            }

            if (x.setting == "principalAge" && principalAge.value == null) {
              // set
              principalAge.value = x.value;
            }

            if (x.setting == "dependantAge" && dependantAge.value == null) {
              // set
              dependantAge.value = x.value;
            }
          });

        } else {
          error.value = err.value;
        }
        
        // is now Ready
        isReady.value = true;
      })();

    });

     // handle back
     const handleBack = () => {
      // emit new parameters
      context.emit("back", {
            id: "settings",
            value: true,
          });
    }

    // submit
    const handleNext = async () => {
      // start
      isSubmitting.value = true;
      error.value = false;

      // Materialize CSS handled all custome errors \\
      const newVal = [
        {
          setting: "familySize",
          value: familySize.value,
          scope: null, // props.newClient.id
        },
        {
          setting: "principalAge",
          value: principalAge.value,
          scope: null, // props.newClient.id
        },
        {
          setting: "dependantAge",
          value: dependantAge.value,
          scope: null, // props.newClient.id
        },
      ];

      // emit new parameters
      context.emit("next", {
          id: "settings",
          value: newVal,
        });

      // // post item
      // const { res, err } = await postItem("rules", newVal);

      // if (res.value) {
      //   // next
      //   // emit new parameters
      //   context.emit("next", {
      //     id: "settings",
      //     value: true,
      //   });
      // } else {
      //   error.value = err.value;
      // }

      // end here
      isSubmitting.value = false;
    };

    return {
      error,
      isReady,
      isSubmitting,
      handleNext,
      handleBack,
      familySize,
      principalAge,
      dependantAge,
    };
  },
};
</script>
  
  <style scoped>
.grey-bg-custom {
  background-color: #f2f2f2;
}
.clickable {
  cursor: pointer;
}
</style>
